import Widgets from '@/widgets'


export default [
	{ name:'username', widget:Widgets.input, attrs: { type:'text',     required:true, placeholder:"Имя пользователя", }, icon:'icon-user' },
	{ name:'password', widget:Widgets.input, attrs: { type:'password', required:true, placeholder:"Пароль", }, icon:'icon-lock' },
]
